module.exports = __webpack_public_path__ + "assets/login-frontend/id_perfect-53bf2c099afbb063.png";